import { SIDEMENU_MODE } from '@maxis/client-logic/constants/enumerates';
import { TextInput } from '@maxis/components';
import { useState } from 'react';
import styles from './SideMenu.module.css';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { shallow } from 'zustand/shallow';
import PropTypes from 'prop-types';

const SideMenuSearchTab = ({ sideMenuMode, onMenuClick }) => {
    const menuList = useBoundStore((state) => state.menu.menuList, shallow);

    const [searchText, setSearchText] = useState('');

    const createFilterMenu = (flatMenuList, txt) => {
        if (!flatMenuList || flatMenuList?.length === 0) return;

        return flatMenuList
            ?.filter((f) => {
                if (!f.programRoutePath) return null;
                if (!txt) return f;
                if (f.menuName.includes(txt)) return f;
                if (f.menuId.toUpperCase().includes(txt.toUpperCase())) return f;
                return null;
            })
            .map((e) => {
                return (
                    <li
                        className={styles.menuSearchList}
                        key={e.menuId}
                        //className={addStyle(e)}
                        onClick={() => {
                            onMenuClick(e);
                            //onHandleList(e.children.length > 0 && e.menuId);
                        }}
                    >
                        {e.menuName}
                    </li>
                );
            });
    };

    return (
        <div
            className={styles.inner}
            style={{
                display: sideMenuMode === SIDEMENU_MODE.SEARCH ? 'block' : 'none',
            }}
        >
            <h2>메뉴 검색</h2>
            <ul>
                <div className={styles.menuSearch}>
                    <TextInput
                        onChange={(e) => {
                            setSearchText(e.target.value);
                        }}
                    />
                    <button className={styles.btnMenuSearch}>검색</button>
                </div>
                {createFilterMenu(menuList, searchText)}
            </ul>
        </div>
    );
};

SideMenuSearchTab.propTypes = {
    sideMenuMode: PropTypes.string,
    onMenuClick: PropTypes.func,
};

SideMenuSearchTab.displayName = 'SideMenuSearchTab';
export default SideMenuSearchTab;
